/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {defaultNgxScrollPositionRestorationConfig as ɵc} from './lib/default-ngx-scroll-position-restoration-config';
export {NGX_SCROLL_POSITION_RESTORATION_CONFIG_INJECTION_TOKEN as ɵa} from './lib/ngx-scroll-position-restoration-config-injection-token';
export {NgxScrollPositionRestorationService as ɵb} from './lib/ngx-scroll-position-restoration.service';